import React, { createContext, useCallback, useContext, useState } from 'react';

import { DataOnboarding } from './Interface';

interface OnboardingContextProps {
  dataOnboarding: DataOnboarding;
  updateDataOnboarding: (data: Partial<DataOnboarding>) => void;
}

const OnboardingContext = createContext<OnboardingContextProps | undefined>(undefined);

interface OnboardingProviderProps {
  children: React.ReactNode;
}

export const OnboardingProvider: React.FC<OnboardingProviderProps> = ({ children }) => {
  const [dataOnboarding, setDataOnboarding] = useState<DataOnboarding>({});

  const updateDataOnboarding = useCallback((data: Partial<DataOnboarding>) => {
    // setDataOnboarding((prevData) => ({ ...prevData!, ...data }));
    setDataOnboarding(data as DataOnboarding);
  }, []);

  return (
    <OnboardingContext.Provider value={{ dataOnboarding, updateDataOnboarding }}>{children}</OnboardingContext.Provider>
  );
};

export const useOnboarding = () => {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error('useOnboarding must be used within an OnboardingProvider');
  }
  return context;
};
